/**
 * 埋点（+aplus）
 */

import { getCnEnv } from "@cainiaofe/cn-utils";
import { getUserID, $, setElement } from "./utils";
import { HashRouterPidList, CnWorkNoList } from "./constant";
// import request from "./request";

/**
 * 根据 meta 标签获取pid
 * @returns 'cn_cone_xxx'
 */
const getPid = () => {
  const tag = document.getElementsByTagName("meta")["arms-pid"];
  if (tag) return tag.content;
};

// 设置aplus meta标签 <meta name="aplus-core" content="aplus.js">
const loadAplusMeta = () => {
  if (
    !$('meta[name="aplus-core"]') ||
    $('meta[name="aplus-core"]').content !== "aplus.js"
  ) {
    setElement("meta", 'meta[name="aplus-core"]', {
      name: "aplus-core",
      content: "aplus.js",
    });
  }
};

// 设置aplus 用户信息
const setAplusUid = (uid) => {
  var q = window.aplus_queue || (window.aplus_queue = []);
  q.push({
    action: "aplus.setUserProfile",
    arguments: [
      {
        uidaplus: uid,
      },
    ],
  });
};

// 获取员工菜鸟工号
// const queryUserWorkNo = async (aliWorkNo) => {
//   const result = await request({
//     method: "get",
//     url: "",
//     params: {
//       aliWorkNo,
//     },
//   });
//   return result?.data;
// };

// 加载coneArms cdn（latest）
const loadArmsCdn = (callback) => {
  if (!window.coneArms) {
    const armsCdnUrl = "https://o.alicdn.com/cn-arch-fe/cone-arms-stable/index.umd.es5.production.js";

    setElement(
      "script",
      'script[src*="/cone-arms-latest/index.umd.es5.production.js"]',
      {
        crossorigin: "anonymous",
        src: armsCdnUrl,
      },
      callback
    );
  }
};

const getPvPluginOptions = (pid) => {
  let pvPluginOptions = {
    autoPV: true,
  };

  if (HashRouterPidList.includes(pid)) {
    pvPluginOptions = {
      ...pvPluginOptions,
      enableHash: true,
    };
  } else {
    pvPluginOptions = {
      ...pvPluginOptions,
      enableHistory: true,
    };
  }
  console.log('pvPluginOptions--', pvPluginOptions);
  return pvPluginOptions;
};

// 初始化 coneArms 实例
export const initArms = () => {
  const aliWorkNo = getUserID();

  const loadAplus = () => {
    loadAplusMeta();
    aliWorkNo && setAplusUid(aliWorkNo);
  };

  const loadArms = () => {
    const pid = getPid();
    if (!pid) return;

    loadArmsCdn(() => {
      if (!window.coneArms) return;
      const pvPluginOptions = getPvPluginOptions(pid);
      const env = location.host.startsWith('uat-') ? 'pre' : getCnEnv();

      const trace = window.coneArms.initTrace({
        pid,
        // uid: aliWorkNo,
        requiredFields: ['uid'],
        env,
        pvPluginOptions,
        apiPluginOptions: {
          enableParams: false, // 屏蔽接口入参
        },
      });

      if (env === 'prod' && CnWorkNoList.includes(pid)) {
        fetch("/_gw/cnMdmIntegrationService/getCurrentLoginCnEmpNo.json")
          .then((res) => res.json())
          .then((res) => {
            if (res && res.success) {
              console.log('res---', res.content);
              trace?.setConfig({ uid: res.content || aliWorkNo });
            }
          })
          .catch((e) => { 
            console.log('e', e);
            trace?.setConfig({ uid: aliWorkNo });
          });
      } else {
        trace?.setConfig({
          uid: aliWorkNo
        })
      }
    });
  };

  loadAplus();
  loadArms();
};
